import type { MessageResponse } from "../../../../shared/apiTypes";
import api from "../api";
import { apiWriteThunk } from "../apiWriteThunk";

import { CLEAR_MESSAGE, ADD_AD, GET_ADS, UPDATE_ADD } from "./adTypes";
import { GET_ERRORS } from "../errorServices/errorTypes";

export const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_MESSAGE,
  });
};

// SCRUM-2119: a failed create rejects into the central hub. Callers do not read
// the return value; the list refresh stays here so a fire-and-forget dispatch
// still reloads the table.
export const AddingAd = apiWriteThunk(
  "ads/add",
  (data) => api.post<MessageResponse>("/api/ads/add", data),
  (dispatch, body) => {
    dispatch({ type: ADD_AD, payload: body });
    dispatch(getAds());
  }
);

export const UpdatingAd = apiWriteThunk(
  "ads/update",
  (data) => api.put<MessageResponse>("/api/ads/update", data),
  (dispatch, body) => {
    dispatch({ type: UPDATE_ADD, payload: body });
    dispatch(getAds());
  }
);

export const getAds = () => async (dispatch) => {
  await api
    .get("/api/ads")
    .then((res) => {
      dispatch({
        type: GET_ADS,
        payload: res.data.reverse(),
      });
    })
    .catch((err) => {
      // Surface a failed fetch as an error toast via the shared errors slice,
      // instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};

// Resolves to true once the delete succeeded, so the screen can confirm it
// (SCRUM-1944); a failed delete still resolves (to undefined) via GET_ERRORS.
export const deleteAd = (id) => async (dispatch) => {
  return api
    .delete(`/api/ads/delete/${id}`)
    .then(() => {
      dispatch(getAds());
      return true;
    })
    .catch((err) => {
      // Surface a failed delete as an error toast via the shared errors slice,
      // instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};
